import { useLocation, Link } from "react-router-dom";

import { Menu, Tag } from "antd-v4";

import navigation from "../../../../navigation/vertical";
import { useCustomise } from "../../../../context/customiseContext";

export default function MenuItem(props) {
  const { onClose } = props;

  // Context
  const { theme } = useCustomise();

  // Location
  const location = useLocation();
  const { pathname } = location;

  const splitLocation = pathname.split("/");

  // Menu
  const splitLocationUrl =
    splitLocation[splitLocation.length - 2] +
    "/" +
    splitLocation[splitLocation.length - 1];

  // Recursive function to convert navigation into menu items format
  const convertToMenuItems = (navItems) => {
    return navItems.map((item, _) => {
      if (item.header) {
        return {
          type: "group",
          label: item.header,
        };
      }

      if (item.children) {
        const childrenItems = item.children.map((itemChildren) => {
          if (!itemChildren.children) {
            const childrenNavLink = itemChildren.navLink.split("/");
            const isSelected =
              splitLocationUrl ===
              childrenNavLink[childrenNavLink.length - 2] +
                "/" +
                childrenNavLink[childrenNavLink.length - 1];

            return {
              key: itemChildren.id,
              label: (
                <Link to={itemChildren.navLink} onClick={onClose}>
                  <span className="hp-text-color-black-100 hp-text-color-dark-0">
                    {itemChildren.title}
                  </span>
                </Link>
              ),
              className: isSelected
                ? "ant-menu-item-selected"
                : "ant-menu-item-selected-in-active",
            };
          } else {
            // Level 3
            const level3Items = itemChildren.children.map((childItem) => {
              const childrenItemLink = childItem.navLink.split("/");
              const isSelected =
                splitLocationUrl ===
                childrenItemLink[childrenItemLink.length - 2] +
                  "/" +
                  childrenItemLink[childrenItemLink.length - 1];

              return {
                key: childItem.id,
                label: (
                  <Link to={childItem.navLink} onClick={onClose}>
                    <span className="hp-text-color-black-100 hp-text-color-dark-0">
                      {childItem.title}
                    </span>
                  </Link>
                ),
                className: isSelected
                  ? "ant-menu-item-selected"
                  : "ant-menu-item-selected-in-active",
              };
            });

            return {
              key: itemChildren.id,
              label: itemChildren.title,
              children: level3Items,
            };
          }
        });

        return {
          key: item.id,
          icon: item.icon,
          label: item.title,
          children: childrenItems,
        };
      } else {
        // Level 1
        const itemNavLink = item.navLink ? item.navLink.split("/") : "";
        const isSelected =
          splitLocation[splitLocation.length - 2] +
            "/" +
            splitLocation[splitLocation.length - 1] ===
          itemNavLink[itemNavLink.length - 2] +
            "/" +
            itemNavLink[itemNavLink.length - 1];

        return {
          key: item.id,
          icon: item.icon,
          label: item.tag ? (
            <a
              href="#"
              className="hp-d-flex hp-align-items-center hp-d-flex-between"
              onClick={(e) => e.preventDefault()}
            >
              <span className="hp-text-color-black-100 hp-text-color-dark-0">
                {item.title}
              </span>
              <Tag
                className="hp-mr-0 hp-border-none hp-text-color-black-100 hp-bg-success-3 hp-border-radius-full hp-px-8"
                style={{ marginRight: -14 }}
              >
                {item.tag}
              </Tag>
            </a>
          ) : (
            <Link to={item.navLink} onClick={onClose}>
              <span className="hp-text-color-black-100 hp-text-color-dark-0">
                {item.title}
              </span>
            </Link>
          ),
          className: isSelected
            ? "ant-menu-item-selected"
            : "ant-menu-item-selected-in-active",
          style: item.tag && { pointerEvents: "none" },
        };
      }
    });
  };

  const menuItems = convertToMenuItems(navigation);

  return (
    <Menu
      mode="inline"
      defaultOpenKeys={[
        splitLocation.length === 5
          ? splitLocation[splitLocation.length - 3]
          : null,
        splitLocation[splitLocation.length - 2],
      ]}
      theme={theme == "light" ? "light" : "dark"}
      className="menu-items-main"
      items={menuItems}
    />
  );
}